import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofStrip } from './components/SocialProofStrip';
import { PainSection } from './components/PainSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { UrgencySection } from './components/UrgencySection';
import { PricingSection } from './components/PricingSection';
import { Method12Section } from './components/Method12Section';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostSection } from './components/CostSection';
import { EmotionalCtaSection } from './components/EmotionalCtaSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
import { StickyBar } from './components/StickyBar';
interface AppProps {
  showPurchaseNotifications?: boolean;
  showCostOfInaction?: boolean;
}
export function App({
  showPurchaseNotifications = true,
  showCostOfInaction = true
}: AppProps) {
  return <div className="w-full bg-ink font-sans text-ivory" data-id="element-0" data-mp="3rdaquh0wwahl">
      <Hero data-id="element-1" data-mp="5yk6vxnnffx" />
      <main data-id="element-2" data-mp="5orh0l86u6j">
        <SocialProofStrip data-id="element-3" data-mp="67z9oh5w26u" />
        <PainSection data-id="element-4" data-mp="4n7u7q58zd7" />
        <TomosSection data-id="element-5" data-mp="82kl3wchwbg" />
        <BonosSection data-id="element-6" data-mp="2zl3cxocsjc6w" />
        <UrgencySection data-id="element-7" data-mp="2zlv6yuqqp1v2" />
        <PricingSection title="Elegí tu" titleAccent="MegaPack" data-id="element-8" data-mp="2zmo4r67q0h12" />
        <Method12Section data-id="element-9" data-mp="33m5bs42spm8c" />
        <TestimonialsSection data-id="element-10" data-mp="33nggq77z9011" />
        <GuaranteeSection data-id="element-11" data-mp="33ork45xig5rm" />
        <FaqSection data-id="element-12" data-mp="38m1fe27kzbnd" />
        {showCostOfInaction && <CostSection data-id="element-13" data-mp="38k6ugnwb7jja" />}
        <EmotionalCtaSection data-id="element-14" data-mp="38nupxslbeg0n" />
        <FinalCtaSection data-id="element-15" data-mp="3dkl0y1i9ilf7" />
      </main>
      <Footer data-id="element-16" data-mp="3dlnwwnufze1z" />
      <StickyBar data-id="element-17" data-mp="3dm5ze27p6oic" />
      {showPurchaseNotifications && <PurchaseToast data-id="element-18" data-mp="nw2bq4xkjoqk" />}
    </div>;
}